import { lazy } from "react";
import { Navigate, Route, useLocation } from "react-router-dom";

const ChallengesPage = lazy(() =>
  import("./pages/steps-page").then((m) => ({ default: m.ChallengesPage })),
);
const PastChallengesPage = lazy(() =>
  import("./pages/steps/past-challenges-page").then((m) => ({ default: m.PastChallengesPage })),
);
const PastChallengeDetailPage = lazy(() =>
  import("./pages/steps/past-challenge-detail-page").then((m) => ({
    default: m.PastChallengeDetailPage,
  })),
);

const Awards = lazy(() =>
  import("./pages/awards/awards-page").then((m) => ({ default: m.AwardsPage })),
);
const AwardDetail = lazy(() =>
  import("./pages/awards/award-detail-page").then((m) => ({ default: m.AwardDetailPage })),
);
const RouteAwards = lazy(() =>
  import("./pages/awards/route-awards-page").then((m) => ({ default: m.RouteAwardsPage })),
);
const RouteDetail = lazy(() =>
  import("./pages/awards/route-detail-page").then((m) => ({ default: m.RouteDetailPage })),
);
export function ChallengeEntry() {
  return <ChallengesPage tab="Overview" />;
}
function LegacyStepsEntry() {
  const { search, hash } = useLocation();
  return <Navigate to={`/challenges${search}${hash}`} replace />;
}
export function challengeRoutes() {
  return (
    <>
      <Route path="/challenges/awards" element={<Awards />} />
      <Route path="/challenges/awards/:awardId" element={<AwardDetail />} />
      <Route path="/challenges/awards/routes/:instanceId" element={<RouteAwards />} />
      <Route path="/steps" element={<LegacyStepsEntry />} />
      <Route path="/steps/:routeId" element={<RouteDetail />} />
      <Route path="/steps/awards" element={<Awards />} />
      <Route path="/steps/awards/:awardId" element={<AwardDetail />} />
      <Route path="/challenges/walking-routes" element={<ChallengesPage tab="Walking Route" />} />
      <Route path="/challenges/leaderboards" element={<ChallengesPage tab="Leaderboards" />} />
      <Route path="/challenges/past" element={<PastChallengesPage />} />
      <Route path="/challenges/past/:challengeId" element={<PastChallengeDetailPage />} />
      <Route path="/challenges/*" element={<Navigate to="/challenges" replace />} />
    </>
  );
}
